import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, Flex, } from 'antd';
import ProjectAdd from './ProjectAdd';
import ModalDel from '../../cpn/ModalDel';
import ProjectEdit from './ProjectEdit';
import { useBnsXiangMuDelMutation, useBnsXiangMuListQuery } from '../../store/BnsKeJiApi';
import ProjectCheck from './ProjectCheck';
import Copy from '../../cpn/Copy';
import { CopyOutlined, EyeOutlined } from '@ant-design/icons';
function SketchProject() {       
    const e_id = JSON.parse(localStorage.getItem('e_id'))
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsXiangMuListQuery({bxm_e_id:localStorage.getItem('e_id')});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxm_id:key,bxm_content,bxm_ctime,bxm_cname,bxm_num,bxm_dept_name,bxm_name} = item;
                    return item = {key,bxm_content,bxm_ctime,bxm_cname,bxm_num,bxm_dept_name,bxm_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bxm_ctime;
                    let bTimeString = b.bxm_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'list',
            title: '项目名称',
            dataIndex:'bxm_name',                
        },         
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'dept',
            title: '部门',            
            dataIndex: 'bxm_dept_name',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bxm_ctime + record.bxm_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <ProjectEdit bxm_id={record.key}  e_id={e_id} eu_id={eu_id} eu_name={eu_name} />  
                        <ModalDel onOk={() => {
                            del({bxm_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />  
                       <ProjectCheck
                            bxm_name={record.bxm_name} 
                            bxm_id={record.key}
                            bxm_content={record.bxm_content}
                            eu_id={eu_id} 
                            eu_name={eu_name} 
                        />
                        <a onClick={() => {
                            window.open(`https://www.bnsrj.com/SketchProject?bxm_id=${record.key}`)
                        }}><EyeOutlined /> 预览</a>
                        <Copy text={`https://www.bnsrj.com/SketchProject?bxm_id=${record.key}`} title={<><CopyOutlined /> 复制链接</>}></Copy>
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsXiangMuDelMutation()
    return (
        <Main  selectedKeys={['/SketchProject']}>  
            <Flex justify='space-between'>
                <div></div>
                <ProjectAdd e_id={e_id} eu_id={eu_id} eu_name={eu_name}/>                
            </Flex>          
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default SketchProject